"use client";

import React from "react";

import Image from "next/image";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";

import { useRouter } from "next/navigation";

import { cn } from "@/lib/utils";
import { cva, type VariantProps } from "class-variance-authority";

const ICONS = {
  metamask: "/icons/metamask.svg",
  walletconnect: "/icons/walletconnect.svg",
  coinbase: "/icons/coinbase.svg",
  phantom: "/icons/phantom.svg",
};

const authButtonVariants = cva(
  "pl-1 pr-3 py-1 text-white justify-start w-full",
  {
    variants: {
      variant: {
        metamask: "bg-metamask hover:bg-metamask",
        walletconnect: "bg-walletconnect hover:bg-walletconnect",
        coinbase: "bg-coinbase hover:bg-coinbase",
        phantom: "bg-phantom hover:bg-phatom",
      },
    },
    defaultVariants: {
      variant: "metamask",
    },
  },
);

type AutthButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> &
  VariantProps<typeof authButtonVariants> & {
    isRecent?: boolean;
  };

const AuthButton = React.forwardRef<HTMLButtonElement, AutthButtonProps>(
  ({ variant = "metamask", className, isRecent, ...props }, ref) => {
    const { push } = useRouter();

    return (
      <Button
        size="lg"
        className={cn(authButtonVariants({ variant, className }))}
        ref={ref}
        onClick={() => push("/portfolio")}
        {...props}
      >
        <div className="grid h-full w-8 shrink-0 place-items-center rounded-md bg-white">
          <Image
            src={ICONS[variant || "metamask"]}
            alt={variant || ""}
            width={256}
            height={256}
            className="size-4"
          />
        </div>
        <div
          className={cn("w-full text-center", {
            "xs:text-start": isRecent,
          })}
        >
          Connect with <span className="capitalize">{variant}</span>
        </div>
        {isRecent && (
          <Badge className="xs:inline-flex ml-auto hidden border-white/10 bg-white/10 px-1.5 py-0.5 text-white shadow-none">
            Recent
          </Badge>
        )}
      </Button>
    );
  },
);

AuthButton.displayName = "AuthButton";

export { AuthButton };
